import UploadModel from '@/Models/uploadModel';
import { UploadType } from '@/Types/Enums/uploadType';
import BaseUploadModel from '@/Models/baseUploadModel';
import { UploadStatus } from '@/Types/Enums/uploadStatus';

export default class FolderUploadModel implements BaseUploadModel {
  type: UploadType;
  children: UploadModel[];
  fileName: string;
  personaDisplayName: string;
  cameraName: string;
  comments: string;
  addedTimestamp: string;
  rootFolderName: string;

  hasUploadInfoChanged: boolean = false;
  isFolder: boolean = true;

  public get size():number {
    return this.children.reduce(function (total, upload) {
      return total + upload.size;
    }, 0);
  }

  public get bytesUploaded(): number {
    return this.children.reduce(function (total, upload) {
      return total + upload.bytesUploaded;
    }, 0);
  }

  public get statusName(): UploadStatus {
    if (this.children.every(function (file) {
      return file.statusName === UploadStatus.Uploaded;
    })) {
      return UploadStatus.Uploaded;
    }
    if (this.children.some(function (file) {
      return file.statusName === UploadStatus.FailedAuthorisation;
    })) {
      return UploadStatus.FailedAuthorisation;
    }
    if (this.children.some(function (file) {
      return file.statusName === UploadStatus.Cancelled;
    })) {
      return UploadStatus.Cancelled;
    }
    if (this.children.some(function (file) {
      return file.statusName === UploadStatus.Failed;
    })) {
      return UploadStatus.Failed;
    }
    if (this.children.some(function (file) {
      return file.statusName === UploadStatus.Authorising;
    })) {
      return UploadStatus.Authorising;
    }
    if (this.children.some(function (file) {
      return file.statusName === UploadStatus.Uploading;
    })) {
      return UploadStatus.Uploading;
    }
    return UploadStatus.Pending;
  }

  public get uploadId() {
    return this.children[0].uploadId;
  }

  get isAuthorising(): boolean {
    return this.statusName === UploadStatus.Authorising;
  }
  get progress(): number {
    return Math.floor(((this.bytesUploaded / this.size) * 100));
  }

  getSortingValue(fieldName: string) {
    switch (fieldName) {
    case 'addedTimestamp':
      return this.addedTimestamp;
    case 'fileName':
      return this.fileName;
    case 'size':
      return this.size;
    case 'statusName':
      return this.statusName;
    case 'userName':
      return this.personaDisplayName;
    case 'path':
      return this.rootFolderName;
    }
  }

  constructor(uploads: UploadModel[]) {
    this.type = uploads[0].type;
    this.children = uploads;

    this.fileName = this.children[0].rootFolderName!;
    this.personaDisplayName = this.children[0].personaDisplayName;
    this.cameraName = this.children[0].cameraName;
    this.comments = this.children[0].comments;
    this.addedTimestamp = this.children[0].addedTimestamp;
    this.rootFolderName = this.children[0].rootFolderName!;

    this.hasUploadInfoChanged = false;
  }

  getAllIds() {
    return this.children.map(u => u.uploadId);
  }

  getAllStatuses(): string[] {
    return this.children.map(u => u.statusName);
  }

  getUploadsLength() {
    return this.children?.length ?? 0;
  }

  setFailedAuthorization() {
    this.children.forEach(c => c.statusName = UploadStatus.FailedAuthorisation);
  }
}